<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="780px">
		<v-card>
			<v-card-title class="headline">
				<v-icon>check</v-icon> Ver seguimiento  
				<v-spacer></v-spacer>
				<v-btn icon @click="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-0">
				<v-container grid-list-md class="pt-0">
					<v-layout row wrap>
						
						<v-flex xs12>
							<h3><strong>Número de papeleta:</strong>   {{permiso.numero }}</h3>
						</v-flex>
						<v-flex xs12>
							<h3><strong>Funcionario:</strong>   {{ permiso.nombres }}</h3>
						</v-flex>
						<v-flex xs12>
							<h3><strong>Tipo de papeleta:</strong>   {{ permiso.tipo_permiso }}</h3>
						</v-flex>
						<v-flex xs12 v-if="permiso.tipo_permiso == 'PERMISO OFICIAL POR HORAS'">
							<h3><strong>Motivo:</strong> {{ permiso.permiso.motivo }}</h3>
						</v-flex>
					</v-layout>
					<h3><strong>Detalles de papeleta</strong></h3>
					<v-layout>
						<v-flex xs12> 
							<v-data-table
								:items="detalle_seguimiento"
								class="elevation-1"
								hide-actions
								:headers="headers"
							>
								<template v-slot:items="props">
							<td class="text-xs-center">{{ $moment(props.item._created_at).format("DD/MM/YYYY HH:mm") }} </td>
							<td class="text-xs-center">{{ props.item.estado.descripcion }}</td>
							<td class="text-xs-center">{{ props.item.usuario?props.item.usuario.nombre_usuario:"" }}</td>

									
								</template>
							</v-data-table>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs12>
						  <h4><strong>Total horas: {{ horas_solicitadas.toFixed(2) }}</strong></h4>
						</v-flex>
					</v-layout>

				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="error"
					type="submit"
					@click.prevent="close()"
				><v-icon>clear</v-icon> 
					Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate';
import SeguimientoDetalle from '../components/SeguimientoDetalle'

export default {
	components: {
		SeguimientoDetalle
	},
	mixins: [validate ],
	props: ['item'],
	mounted () {
		this.$bus.$on('openDialogVerSeguimiento', item => {
			 this.permiso = item;
			 
			 this.getDetalleSeguimiemto(this.permiso.permiso.id);
			
			this.dialog = true
		});
    
    
	},
	data () {
		return {
			dialog: false,
			detalle_seguimiento:[],
			permiso: {
				permiso: {
					motivo: ''
				}
			},
				permiso_detalle:{
					id:'',
					id_permiso:'',
					feha_desde:'',
					fecha_hasta:''
				},
				permiso_seguimiento:{
				
				},
				vDetallePermisos:{
					
					id_permiso:'',
					feha_desde:'',
					fecha_hasta:''
				},

			loading: false,
			headers: [
				{
					text: 'Fecha registro',
					sortable: false,
					align: 'center'
				},
				{
					text: 'Estado',
					sortable: false,
					align: 'center'
				},
				{
					text: 'Usuario',
					sortable: false,
					align: 'center'
				}
				
			],
			horas_solicitadas: 0
		}
	},
	methods: {
		close () {
			this.dialog = false
			this.permiso = {
				permiso: {
					motivo: ''
				}
			}

		},

		

	async getDetalleSeguimiemto(id) {
	//console.log(id);
	  try {
        let res = await this.$service.graphql({
          query: `
                query{
                seguimientoDetalles(id_permiso: ${id}){
                  rows{
                      id
                      _created_at
                          id_estado      
                      estado{
                        id 
                        descripcion
                      }
                      _user_created
                        usuario{
                          id 
                          nombre_usuario
                        }
                      }
                  }
                }

          `,
        });

        this.detalle_seguimiento = res.seguimientoDetalles.rows;
      } catch (error) {
        console.log(error);
      }
    },
	
		aprobarRechazar (id_permiso, id_estado) {
			this.loading = true
			this.$service.graphql({
				query: `
					query {
						apruebaControlPermiso(id_tipo_permiso: ${id_permiso}, id_estado: ${id_estado}, id_jefe: ${this.getUserId()}){
							mensaje
						}
					}
				`,
			}).then(response => {
				if (response.apruebaControlPermiso.mensaje === 'ok') {
					this.$message.success()
					this.$bus.$emit('closeDialog')
					this.close()
				} else {
					this.$message.error(response.apruebaControlPermiso.mensaje)
					this.close
				}
			});
			this.loading = false
		},
		
		// sumar_horas (permiso_detalles) {
		// 	let total = 0
		// 	console.log('id_permiso::::'+permiso_detalles)
		// 	permiso_detalles.forEach(item => {
		// 		total += this.$moment(item.fecha_hasta+' '+item.hora_hasta).diff(item.fecha_desde+' '+item.hora_desde, 'minutes') / 60
		// 	})
		// 	this.horas_solicitadas = total
		// //sumar_horas () {
		// 	// let total = 0
		// 	// permiso_detalles.forEach(item => {
		// 	// 	total += this.$moment(item.fecha_hasta+' '+item.hora_hasta).diff(item.fecha_desde+' '+item.hora_desde, 'minutes') / 60
		// 	// })
		// 	// this.horas_solicitadas = total
		// },
		getUserId () {
      const user = this.$storage.get('user')
      return user.id_persona
    }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/VerSeguimiento.vue